"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _formatDistance = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatDistance"));

var _formatRelative = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatRelative"));

var _localize = _interopRequireDefault(require("date-fns/locale/ru/_lib/localize"));

var _match = _interopRequireDefault(require("date-fns/locale/ru/_lib/match"));

var _formatLong = _interopRequireDefault(require("date-fns/locale/ru/_lib/formatLong"));

var _buildLocalizeFn = _interopRequireDefault(require("date-fns/locale/_lib/buildLocalizeFn"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var monthValues = {
  narrow: 'Я Ф М А М И И А С О Н Д'.split(' '),
  abbreviated: 'янв фев мар апр мая июн июл авг сен окт ноя дек'.split(' '),
  wide: 'января февраля марта апреля мая июня июля августа сентября октября ноября декабря'.split(' ') // wide: 'январь февраль март апрель май июнь июль август сентябрь октябрь ноябрь декабрь'.split(
  //   ' '
  // ),

};
var ruLocale = {
  formatDistance: _formatDistance["default"],
  formatLong: _formatLong["default"],
  formatRelative: _formatRelative["default"],
  localize: _objectSpread(_objectSpread({}, _localize["default"]), {}, {
    month: (0, _buildLocalizeFn["default"])({
      values: monthValues,
      defaultWidth: 'wide',
      defaultFormattingWidth: 'wide'
    })
  }),
  match: _match["default"],
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var _default = ruLocale;
exports["default"] = _default;